import { unsafeCSS as $, LitElement as S } from "lit";
import { html as s, unsafeStatic as A } from "lit/static-html.js";
import { state as P, property as b } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { registerComponent as R } from "@aileron/button-icon";
import { registerComponent as W } from "@aileron/icon";
import { ifDefined as H } from "lit/directives/if-defined.js";
const M = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.collapse{visibility:collapse}.static{position:static}.-mt-px{margin-top:-1px}.mt-5{margin-top:1.25rem}.box-border{box-sizing:border-box}.inline{display:inline}.flex{display:flex}.table{display:table}.hidden{display:none}.h-12{height:3rem}.h-9{height:2.25rem}.w-12{width:3rem}.w-9{width:2.25rem}.cursor-pointer{cursor:pointer}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.items-center{align-items:center}.justify-center{justify-content:center}.rounded{border-radius:.25rem}.border{border-width:1px}.border-solid{border-style:solid}.border-blue-060{border-color:#0860c4}.border-blue-070{border-color:#0a78f5}.border-blue-080{border-color:#3b93f7}.border-neutral-050{border-color:#405164}.border-neutral-090{border-color:#b4c1cf}.border-transparent{border-color:transparent}.bg-blue-060{background-color:#0860c4}.bg-blue-070{background-color:#0a78f5}.bg-blue-080{background-color:#3b93f7}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-040{background-color:#303d4b}.bg-neutral-050{background-color:#405164}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-100{background-color:#e6eaef}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-transparent{background-color:transparent}.p-0{padding:0}.text-blue-060{color:#0860c4}.text-blue-080{color:#3b93f7}.text-neutral-000{color:#101419}.text-neutral-050{color:#405164}.text-neutral-090{color:#b4c1cf}.text-neutral-140{color:#fff}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}.hover\\:border-blue-070:hover{border-color:#0a78f5}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-2:focus{outline-width:2px}.focus\\:outline-offset-2:focus{outline-offset:2px}.focus\\:outline-blue-070:focus{outline-color:#0a78f5}.active\\:border-blue-080:active{border-color:#3b93f7}.active\\:bg-blue-080:active{background-color:#3b93f7}.active\\:bg-neutral-100:active{background-color:#e6eaef}.active\\:bg-neutral-110:active{background-color:#eceff3}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:border-neutral-090:disabled{border-color:#b4c1cf}.disabled\\:bg-neutral-090:disabled{background-color:#b4c1cf}.disabled\\:text-neutral-090:disabled{color:#b4c1cf}.dark\\:border-blue-080:is(:host([aileron-color-scheme=dark]) *){border-color:#3b93f7}.dark\\:bg-blue-080:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:text-blue-080:is(:host([aileron-color-scheme=dark]) *){color:#3b93f7}.dark\\:text-neutral-000:is(:host([aileron-color-scheme=dark]) *){color:#101419}.dark\\:hover\\:bg-blue-070:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:hover\\:bg-neutral-010:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:hover\\:bg-neutral-020:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:hover\\:bg-neutral-030:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:focus\\:bg-blue-080:focus:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:active\\:border-blue-060:active:is(:host([aileron-color-scheme=dark]) *){border-color:#0860c4}.dark\\:active\\:bg-blue-060:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0860c4}.dark\\:active\\:bg-neutral-020:active:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:active\\:bg-neutral-030:active:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:active\\:bg-neutral-040:active:is(:host([aileron-color-scheme=dark]) *){background-color:#303d4b}.dark\\:disabled\\:border-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:disabled\\:bg-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:disabled\\:text-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){color:#405164}', D = $(M), C = "aileron-color-scheme", B = "aileron-color-scheme-change", E = (e) => {
  const n = class n extends e {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (t) => {
        t.detail ? this.setAttribute(C, t.detail) : this.removeAttribute(C);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        B,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const t = document.documentElement.getAttribute(
        C
      );
      t && this.setAttribute(C, t);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        B,
        this.handleSchemeSwitch
      );
    }
  };
  n.styles = [
    D,
    e.styles ?? []
  ];
  let o = n;
  return o;
}, V = (e) => {
  class o extends e {
    constructor(...r) {
      super(...r), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const t = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(t.getElementsByTagName("link")).findIndex(
        (k) => k.href === this.fontLink
      ) === -1) {
        const k = document.createElement("link");
        k.href = this.fontLink, k.rel = "stylesheet", document.head.appendChild(k);
      }
    }
  }
  return o;
}, q = E(V(S));
function N(e, o, n) {
  const r = new CustomEvent(o, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...n
  });
  return e.dispatchEvent(r), r;
}
class K {
  constructor(o, ...n) {
    this.slotNames = [], (this.host = o).addController(this), this.slotNames = n, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((o) => {
      var n;
      if (o.nodeType === o.TEXT_NODE && ((n = o.textContent) == null ? void 0 : n.trim()) !== "")
        return !0;
      if (o.nodeType === o.ELEMENT_NODE) {
        const r = o;
        if (r.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!r.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(o) {
    return this.host.querySelector(`:scope > [slot="${o}"]`) !== null;
  }
  test(o) {
    return o === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(o);
  }
  hostConnected() {
    var o;
    (o = this.host.shadowRoot) == null || o.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var o;
    (o = this.host.shadowRoot) == null || o.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(o) {
    var r, t;
    const n = o.target;
    ((r = this.slotNames) != null && r.includes("[default]") && !n.name || n.name && ((t = this.slotNames) != null && t.includes(n.name))) && this.host.requestUpdate();
  }
}
var U = Object.defineProperty, _ = (e, o, n, r) => {
  for (var t = void 0, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (t = a(o, n, t) || t);
  return t && U(o, n, t), t;
};
const u = "aileron-common-notification", p = {
  root: u,
  iconContainer: `${u}__icon-container`,
  iconContainerInline: `${u}__icon-container--inline`,
  collapseButton: `${u}__collapse-button`,
  closeIcon: `${u}__close-icon`,
  title: `${u}__title`,
  titleHidden: `${u}__title--hidden`,
  titleInline: `${u}__title--inline`
}, w = {
  SUCCESS: "success",
  INFO: "information",
  WARNING: "warning",
  ERROR: "error"
}, X = {
  [w.SUCCESS]: "signal:checkmark",
  [w.INFO]: "signal:information",
  [w.WARNING]: "signal:warning",
  [w.ERROR]: "signal:error"
};
var g;
const m = (g = class extends q {
  constructor(o) {
    super(), this.hasSlotController = new K(
      this,
      "title",
      "footer"
    ), this.closeLabel = "Dismiss", this.fullwidth = !1, this.kind = w.INFO, this.canClose = !1, this.small = !1, this.open = !1, this.customElementString = o;
  }
  _renderTitle() {
    const o = this.hasSlotController.test("title") || !!this.title;
    return s`
      <div
        class="${f({
      [p.titleHidden]: !this.isInline && !o,
      [p.title]: o,
      [p.titleInline]: this.isInline
    })}"
      >
        <slot name="title">${this.title}</slot>
      </div>
    `;
  }
  _renderClose() {
    return this.canClose ? s`
          <${this.createTagName("-notification-common-button-icon")}
            size="sm"
            id="closeNotification"
            label-text="${H(this.closeLabel)}"
            icon="action:close"
            @click=${this._handleClose}
            kind="ghost"
            class="${p.closeIcon}"
          ></${this.createTagName("-notification-common-button-icon")}>
        ` : void 0;
  }
  _renderIcon() {
    return s`<div
      class="${f({
      [p.iconContainer]: !0,
      [p.iconContainerInline]: this.isInline
    })}"
    >
      <${this.createTagName("-notification-common-icon")}
        icon="${X[this.kind]}"
        outlined
        size="${this.isInline ? this.small ? 16 : 24 : 32}"
      ></${this.createTagName("-notification-common-icon")}>
    </div>`;
  }
  _renderExpand() {
    return s`
       <${this.createTagName("-notification-common-button-icon")}
        size="sm"
        id="collapse-expand"
        label-text=${this.open ? "collapse" : "expand"}
        icon="navigation:chevron-down"
        @click=${this._handleOpen}
        kind="ghost"
        class="${p.collapseButton}"
      ></${this.createTagName("-notification-common-button-icon")}>
    `;
  }
  /**
   * Sets the role for a11y purposes. Also sets an id for the notification.
   */
  connectedCallback() {
    R(
      this.customElementString ? this.customElementString + "-notification-common" : "adc-notification-common"
    ), W(
      this.customElementString ? this.customElementString + "-notification-common" : "adc-notification-common"
    ), this.hasAttribute("role") || this.setAttribute("role", "alert"), this.hasAttribute("id") || this.setAttribute("id", `adcNotification_${g.count++}`), super.connectedCallback();
  }
  createTagName(o) {
    return A(
      this.customElementString ? this.customElementString + o : "adc" + o
    );
  }
  /**
   * Whenever the close button is clicked, the notification is removed from the
   * DOM.
   */
  _handleClose() {
    N(this, "adc-close");
    const o = document.querySelector(`#${this.getAttribute("id")}`);
    o && o.parentNode.removeChild(o);
  }
  /**
   * Whenever the expand/collapse button is clicked, the content is collapsed
   * in the DOM.
   */
  _handleOpen() {
    this.open ? N(this, "adc-collapse") : N(this, "adc-expand"), this.open = !this.open;
  }
}, g.count = 0, g);
_([
  P()
], m.prototype, "closeLabel");
_([
  b({ type: Boolean, reflect: !0 })
], m.prototype, "fullwidth");
_([
  b({ reflect: !0 })
], m.prototype, "kind");
_([
  b()
], m.prototype, "title");
_([
  b({ type: Boolean, attribute: "can-close" })
], m.prototype, "canClose");
_([
  b({ type: Boolean })
], m.prototype, "small");
_([
  b({ type: Boolean, reflect: !0 })
], m.prototype, "open");
let T = m;
const O = ":host(.adc-global-notification) .aileron-global-notification__container{display:inline-flex;border:1px solid transparent;justify-content:center;padding:12px 24px;border-width:8px 0px 0px 0px;width:100%}:host(.adc-global-notification) .aileron-global-notification__content{display:flex;max-width:1216px;flex:1}:host(.adc-global-notification) .aileron-global-notification__header-container{color:#1b1f23;display:flex;justify-content:space-between}:host(.adc-global-notification) .aileron-global-notification__header-container--open{margin-bottom:6px}:host(.adc-global-notification) .aileron-global-notification__body-container{max-height:0px;overflow:hidden;margin-right:4px}:host(.adc-global-notification) .aileron-global-notification__body-container--open{overflow:inherit;max-height:200vh;display:block}:host(.adc-global-notification) .aileron-global-notification__body{font-family:AmericanSans Var;font-weight:400;font-size:1rem;line-height:1.5rem;color:#1b1f23;display:flex;flex-direction:column}:host(.adc-global-notification) .aileron-global-notification__footer{flex:0 1 auto;justify-content:flex-end;padding-top:32px;margin-bottom:4px;display:flex}:host(.adc-global-notification) .aileron-global-notification__footer__hidden{display:hidden}:host(.adc-global-notification) .aileron-global-notification__content-wrapper{width:100%}:host(.adc-notification){display:inline-block}:host(.adc-notification):host([fullwidth]){width:100%}:host(.adc-notification) .aileron-notification__container{display:inline-flex;border:1px solid transparent;padding:12px 12px 12px 16px;border-left-width:8px;border-radius:4px}:host(.adc-notification) .aileron-notification__container--full-width{width:100%}:host(.adc-notification) .aileron-notification__header-container{color:#1b1f23;display:flex;justify-content:space-between}:host(.adc-notification) .aileron-notification__header-container--open{margin-bottom:6px}:host(.adc-notification) .aileron-notification__body-container{max-height:0px;overflow:hidden;margin-right:4px}:host(.adc-notification) .aileron-notification__body-container--open{overflow:inherit;max-height:200vh;display:block}:host(.adc-notification) .aileron-notification__body{font-family:AmericanSans Var;font-weight:400;font-size:1rem;line-height:1.5rem;color:#1b1f23;display:flex;flex-direction:column}:host(.adc-notification) .aileron-notification__footer{flex:0 1 auto;justify-content:flex-end;padding-top:32px;margin-bottom:4px;display:flex}:host(.adc-notification) .aileron-notification__footer__hidden{display:hidden}:host(.adc-notification) .aileron-notification__content-wrapper{width:100%}:host .aileron-common-notification__icon-container{display:flex;margin-right:16px;margin-top:2px}:host .aileron-common-notification__icon-container--inline{margin-right:0;margin-top:0;vertical-align:text-top}:host .aileron-common-notification__title{display:block;margin:6px 16px 6px 0;font-family:AmericanSans Var;font-weight:500;font-size:1rem;line-height:1.5rem}:host .aileron-common-notification__title--hidden{display:hidden}:host .aileron-common-notification__title--inline{margin:0 0 0 8px}:host .aileron-common-notification__title--inline:first-letter{text-transform:capitalize}:host .aileron-common-notification__close-icon::part(interactive){color:#006dc0}:host .aileron-common-notification__collapse-button::part(interactive){transform:rotateX(0);color:#006dc0}:host([kind=information]) .aileron-common-notification__icon-container{color:#006dc0}:host([kind=information]) .aileron-global-notification__container,:host([kind=information]) .aileron-inline-notification__container{background-color:#e0f2ff}:host([kind=information]) .aileron-notification__container,:host([kind=information]) .aileron-global-notification__container{border-color:#006dc0}:host([kind=success]) .aileron-common-notification__icon-container{color:#307844}:host([kind=success]) .aileron-global-notification__container,:host([kind=success]) .aileron-inline-notification__container{background-color:#e4f4e8}:host([kind=success]) .aileron-notification__container,:host([kind=success]) .aileron-global-notification__container{border-color:#307844}:host([kind=warning]) .aileron-common-notification__icon-container{color:#b74800}:host([kind=warning]) .aileron-global-notification__container,:host([kind=warning]) .aileron-inline-notification__container{background-color:#ffebde}:host([kind=warning]) .aileron-notification__container,:host([kind=warning]) .aileron-global-notification__container{border-color:#b74800}:host([kind=error]) .aileron-common-notification__icon-container{color:#d6001b}:host([kind=error]) .aileron-global-notification__container,:host([kind=error]) .aileron-inline-notification__container{background-color:#ffe2e6}:host([kind=error]) .aileron-notification__container,:host([kind=error]) .aileron-global-notification__container{border-color:#d6001b}:host([small]) .aileron-common-notification__icon-container--inline{vertical-align:text-top;margin-top:2px}:host([small]) .aileron-common-notification__title{font-family:AmericanSans Var;font-weight:500;font-size:.875rem;line-height:1.25rem}:host([small]) .aileron-inline-notification__container{padding-right:12px!important}:host([open]) .aileron-common-notification__collapse-button::part(interactive){transform:rotateX(180deg)}@media (prefers-color-scheme: dark){:host([aileron-color-scheme=dark]) .aileron-global-notification__header-container,:host([aileron-color-scheme=dark]) .aileron-notification__header-container{color:#f9fafb}:host([aileron-color-scheme=dark]) .aileron-global-notification__body,:host([aileron-color-scheme=dark]) .aileron-notification__body{color:#f9fafb}}:host([aileron-color-scheme=dark]) .aileron-common-notification__close-icon::part(interactive){color:#3aabff}:host([aileron-color-scheme=dark]) .aileron-common-notification__collapse-button::part(interactive){color:#3aabff}@media (prefers-color-scheme: dark){:host([aileron-color-scheme=dark]):host([kind=information]) .aileron-common-notification__icon-container{color:#3aabff}:host([aileron-color-scheme=dark]):host([kind=information]) .aileron-global-notification__container,:host([aileron-color-scheme=dark]):host([kind=information]) .aileron-inline-notification__container{background-color:#003a6a}:host([aileron-color-scheme=dark]):host([kind=information]) .aileron-notification__container,:host([aileron-color-scheme=dark]):host([kind=information]) .aileron-global-notification__container{border-color:#3aabff}:host([aileron-color-scheme=dark]):host([kind=success]) .aileron-common-notification__icon-container{color:#53ba6f}:host([aileron-color-scheme=dark]):host([kind=success]) .aileron-global-notification__container,:host([aileron-color-scheme=dark]):host([kind=success]) .aileron-inline-notification__container{background-color:#1b4225}:host([aileron-color-scheme=dark]):host([kind=success]) .aileron-notification__container,:host([aileron-color-scheme=dark]):host([kind=success]) .aileron-global-notification__container{border-color:#53ba6f}:host([aileron-color-scheme=dark]):host([kind=warning]) .aileron-common-notification__icon-container{color:#ff802e}:host([aileron-color-scheme=dark]):host([kind=warning]) .aileron-global-notification__container,:host([aileron-color-scheme=dark]):host([kind=warning]) .aileron-inline-notification__container{background-color:#602600}:host([aileron-color-scheme=dark]):host([kind=warning]) .aileron-notification__container,:host([aileron-color-scheme=dark]):host([kind=warning]) .aileron-global-notification__container{border-color:#ff802e}:host([aileron-color-scheme=dark]):host([kind=error]) .aileron-common-notification__icon-container{color:#ff798a}:host([aileron-color-scheme=dark]):host([kind=error]) .aileron-global-notification__container,:host([aileron-color-scheme=dark]):host([kind=error]) .aileron-inline-notification__container{background-color:#73000f}:host([aileron-color-scheme=dark]):host([kind=error]) .aileron-notification__container,:host([aileron-color-scheme=dark]):host([kind=error]) .aileron-global-notification__container{border-color:#ff798a}}:host(.adc-inline-notification){display:inline-block}:host(.adc-inline-notification) .aileron-inline-notification__container{border-radius:4px;display:inline-flex;padding:8px 16px 8px 8px;color:#1b1f23}:host(.adc-inline-notification) .aileron-inline-notification__container--full-width{width:100%}:host(.adc-inline-notification):host([fullwidth]){display:block}:host(.adc-inline-notification):host([variant=ghost]) .aileron-inline-notification__container{background-color:transparent}:host(.adc-inline-notification):host([variant=ghost]):host([kind=information]) .aileron-inline-notification__container{color:#006dc0}:host(.adc-inline-notification):host([variant=ghost]):host([kind=success]) .aileron-inline-notification__container{color:#307844}:host(.adc-inline-notification):host([variant=ghost]):host([kind=warning]) .aileron-inline-notification__container{color:#b74800}:host(.adc-inline-notification):host([variant=ghost]):host([kind=error]) .aileron-inline-notification__container{color:#d6001b}@media (prefers-color-scheme: dark){:host(.adc-inline-notification):host([aileron-color-scheme=dark]) .aileron-inline-notification__container{color:#f9fafb}:host(.adc-inline-notification):host([aileron-color-scheme=dark]):host([variant=ghost]):host([kind=information]) .aileron-inline-notification__container{color:#3aabff}:host(.adc-inline-notification):host([aileron-color-scheme=dark]):host([variant=ghost]):host([kind=success]) .aileron-inline-notification__container{color:#53ba6f}:host(.adc-inline-notification):host([aileron-color-scheme=dark]):host([variant=ghost]):host([kind=warning]) .aileron-inline-notification__container{color:#ff802e}:host(.adc-inline-notification):host([aileron-color-scheme=dark]):host([variant=ghost]):host([kind=error]) .aileron-inline-notification__container{color:#ff798a}}:host(.adc-notification),:host(.adc-global-notification) ::slotted(p){margin:0}:host(.adc-notification) ::slotted([slot=link]),:host(.adc-global-notification) ::slotted([slot=link]){margin-top:12px!important;width:fit-content}";
var G = Object.defineProperty, J = (e, o, n, r) => {
  for (var t = void 0, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (t = a(o, n, t) || t);
  return t && G(o, n, t), t;
};
const Q = E(S), l = "aileron-notification", d = {
  root: l,
  container: `${l}__container`,
  headerContainer: `${l}__header-container`,
  headerContainerOpen: `${l}__header-container--open`,
  bodyContainer: `${l}__body-container`,
  bodyContainerOpen: `${l}__body-container--open`,
  body: `${l}__body`,
  footer: `${l}__footer`,
  footerHidden: `${l}__footer--hidden`,
  containerFullWidth: `${l}__container--full-width`,
  contentWrapper: `${l}__content-wrapper`
}, L = class L extends T {
  constructor(o) {
    super(o), this.isInline = !1, this.isCollapsible = !1, this.customElementString = o;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-notification");
  }
  _renderFooter() {
    return s`<div
      part="footer"
      class="${f({
      [d.footer]: this.hasSlotController.test("footer"),
      [d.footerHidden]: !this.hasSlotController.test("footer")
    })}"
    >
      <slot name="footer"></slot>
    </div>`;
  }
  _renderText() {
    return s`
      <div
        class="${f({
      [d.bodyContainer]: !0,
      [d.bodyContainerOpen]: this.isCollapsible ? this.open : this.hasSlotController.test("link") || this.hasSlotController.test("[default]")
    })}"
      >
        <div class="${d.body}">
          <slot></slot>
          <slot name="link"></slot>
        </div>
        ${this.isCollapsible ? this._renderFooter() : ""}
      </div>
    `;
  }
  createTagName(o) {
    return A(
      this.customElementString ? this.customElementString + o : "adc" + o
    );
  }
  render() {
    return s`
      <div
        class="
      ${f({
      [d.container]: !0,
      [d.containerFullWidth]: this.fullwidth
    })}"
      >
        ${this._renderIcon()}
        <div class="${d.contentWrapper}">
          <div
            class="${f({
      [d.headerContainer]: !0,
      [d.headerContainerOpen]: this.isCollapsible ? this.open : this.hasSlotController.test("link") || this.hasSlotController.test("[default]")
    })}"
          >
            ${this._renderTitle()}
            ${this.isCollapsible ? this._renderExpand() : this._renderClose()}
          </div>
          ${this.hasSlotController.test("link") || this.hasSlotController.test("[default]") ? this._renderText() : ""}
        </div>
      </div>
    `;
  }
};
L.styles = [Q.styles || [], $(O)];
let v = L;
J([
  b({ reflect: !0, type: Boolean, attribute: "is-collapsible" })
], v.prototype, "isCollapsible");
try {
  customElements.define("adc-notification", v), console.warn(
    "@aileron/notification is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/notification"
  );
} catch {
}
function Y(e) {
  try {
    customElements.define(
      `${e}-notification`,
      class extends v {
        constructor() {
          super(e);
        }
      }
    );
  } catch {
  }
}
var Z = Object.defineProperty, oo = (e, o, n, r) => {
  for (var t = void 0, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (t = a(o, n, t) || t);
  return t && Z(o, n, t), t;
};
const to = E(S), I = "aileron-inline-notification", j = {
  root: I,
  container: `${I}__container`,
  containerFullWidth: `${I}__container--full-width`
}, z = class z extends T {
  constructor() {
    super(...arguments), this.variant = "default", this.isInline = !0;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-inline-notification");
  }
  render() {
    return s`
      <div
        class="${f({
      [j.container]: !0,
      [j.containerFullWidth]: this.fullwidth
    })}"
      >
        ${this._renderIcon()} ${this._renderTitle()}
      </div>
    `;
  }
};
z.styles = [to.styles || [], $(O)];
let y = z;
oo([
  b({ reflect: !0 })
], y.prototype, "variant");
try {
  customElements.define("adc-inline-notification", y), console.warn("@aileron/notification is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/notification");
} catch {
}
function eo(e) {
  try {
    customElements.define(
      `${e}-inline-notification`,
      class extends y {
        constructor() {
          super(e);
        }
      }
    );
  } catch {
  }
}
var no = Object.defineProperty, io = (e, o, n, r) => {
  for (var t = void 0, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (t = a(o, n, t) || t);
  return t && no(o, n, t), t;
};
const ro = E(S), c = "aileron-global-notification", h = {
  root: c,
  container: `${c}__container`,
  content: `${c}__content`,
  headerContainer: `${c}__header-container`,
  headerContainerOpen: `${c}__header-container--open`,
  bodyContainer: `${c}__body-container`,
  bodyContainerOpen: `${c}__body-container--open`,
  body: `${c}__body`,
  footer: `${c}__footer`,
  footerHidden: `${c}__footer--hidden`,
  contentWrapper: `${c}__content-wrapper`
}, F = class F extends T {
  constructor(o) {
    super(o), this.isInline = !1, this.isCollapsible = !1, this.customElementString = o;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-global-notification");
  }
  _renderFooter() {
    return s`<div
      part="footer"
      class="${f({
      [h.footer]: this.hasSlotController.test("footer"),
      [h.footerHidden]: !this.hasSlotController.test("footer")
    })}"
    >
      <slot name="footer"></slot>
    </div>`;
  }
  _renderText() {
    return s`
      <div
        class="${f({
      [h.bodyContainer]: !0,
      [h.bodyContainerOpen]: this.isCollapsible ? this.open : this.hasSlotController.test("link") || this.hasSlotController.test("[default]")
    })}"
      >
        <div class="${h.body}">
          <slot></slot>
          <slot name="link"></slot>
        </div>
        ${this.isCollapsible ? this._renderFooter() : ""}
      </div>
    `;
  }
  createTagName(o) {
    return A(
      this.customElementString ? this.customElementString + o : "adc" + o
    );
  }
  render() {
    return s`
      <div class="${h.container}">
        <div class="${h.content}">
          ${this._renderIcon()}
          <div class="${h.contentWrapper}">
            <div
              class="${f({
      [h.headerContainer]: !0,
      [h.headerContainerOpen]: this.isCollapsible ? this.open : this.hasSlotController.test("link") || this.hasSlotController.test("[default]")
    })}"
            >
              ${this._renderTitle()}
              ${this.isCollapsible ? this._renderExpand() : this._renderClose()}
            </div>
            ${this.hasSlotController.test("link") || this.hasSlotController.test("[default]") ? this._renderText() : ""}
          </div>
        </div>
      </div>
    `;
  }
};
F.styles = [ro.styles || [], $(O)];
let x = F;
io([
  b({ reflect: !0, type: Boolean, attribute: "is-collapsible" })
], x.prototype, "isCollapsible");
try {
  customElements.define("adc-global-notification", x), console.warn("@aileron/notification is deprecated. Please use @aileron/lit-components instead. For migration documentation, see aileron.aa.com/components/notification");
} catch {
}
function ao(e) {
  try {
    customElements.define(
      `${e}-global-notification`,
      class extends x {
        constructor() {
          super(e);
        }
      }
    );
  } catch {
  }
}
function mo(e) {
  try {
    Y(e), eo(e), ao(e);
  } catch {
  }
}
export {
  x as GlobalNotification,
  y as InlineNotification,
  v as Notification,
  mo as registerComponent,
  ao as registerGlobalNotification,
  eo as registerInlineNotification,
  Y as registerNotification
};
